import { Outlet, } from "react-router-dom";
const FullLayoutLogin = () => {

    return (
        <div><Outlet /></div>
    );
};

export default FullLayoutLogin;